import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button, Form, FormGroup, FormText, Input, Label, Table } from 'reactstrap';
import { GoCheck, GoCircleSlash } from 'react-icons/go';
import { connect } from 'react-redux';

class CounTX extends Component {
    constructor(props) {
        super(props);
        this.state = {
            returnable: this.props.reduxData.userInfo,
            tableData: [],
            addResponse: "",
            deleteResponse: "",
            deletedVal: "",
            pcidName: ""
        }
        this.getTableData();
    }

    getUserInfo() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        //let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        //this.props.updateFetchTime();
        //fetch('user', { method: 'GET', headers: { 'Authorization': bearerVAR } })
        //    .then((response) => response.json())
        //    .then((responseJSON) => { this.writeUserData(responseJSON) })
        //.then((responseSIG) => { this.getTableData() })
        //localStorage.setItem("lastFetch", moment());
        //this.writeUserData(this.props.reduxData.userInfo)
        this.getTableData()
    }

    writeUserData(input) {
        this.setState({
            returnable: input
        })
        this.getTableData();
    }

    async getTableData() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        const response = await fetch('GetCounTX', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            tableData: data
            })
    }

    componentDidMount() {

    }

    async addCounselor(e) {
        e.preventDefault();
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        //localStorage.setItem("lastFetch", moment());
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        //console.log("add counselor");
        const dataInput = new FormData(e.target);
        if (dataInput.get("txid") != "" && dataInput.get("pcid") != ""){
            let toSend = {
                userLevel: this.props.reduxData.userInfo.level.pk,
                txid: dataInput.get('txid'),
                pcid: dataInput.get('pcid')
            }
            const response = await fetch('AddCounsTX', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            })
            const data = await response.json();
            let dataString = "" //Over the course of this action's lifecycle I switch this response value back and forth between a bool and a string like sixteen times. This is shameful.
            if (data == true) dataString = "yes"; else dataString = "no";
            this.setState({
                addResponse: dataString
            })
        }
        this.getTableData();
        setTimeout(() => {
            this.setState({
                addResponse: ""
            })
        }, 4000)
    }

    async deleteCounTX(pk) {
        //console.log("delete " + pk);
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            txid: pk
        }
        const response = await fetch('DeleteCounsTX', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        let dataString = ""
        if (data == true) dataString = "yes"; else dataString = "no";
        this.setState({
            deleteResponse: dataString,
            deletedVal: pk
        })
        this.getTableData();
        setTimeout(() => {
            this.setState({
                deleteResponse: "",
                deletedVal: ""
            })
        }, 4000)
    }

    async nameLookup(e) {
        ////console.log("enter change");
        this.props.updateFetchTime();
        if (e.target.value.length == 10) {
            //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
            let bearerVAR = "Bearer " + this.props.reduxData.apiKey
            
            let toSend = {
                stuPCID: e.target.value,
                userLevel: this.props.reduxData.userInfo.level.pk
            }
            //this.getCounCode(e.target.value);
            const response = await fetch('stuLookupCounselor', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            });
            const data = await response.json();

            this.setState({
                pcidName: data.stuName
            });
        } else {
            this.setState({
                pcidName: ""
            })
        }
        //localStorage.setItem("lastFetch", moment());
    }

    render() {
        return (
            <div>
                <Form className="d-flex" inline onSubmit={this.addCounselor.bind(this)}>
                    <FormGroup>
                        <Label>TargetX ID</Label>
                        <Input type="text" name="txid" id="txid" />
                    </FormGroup>
                    &nbsp;
                    <FormGroup>
                        <Label>PCID</Label>
                        <Input type="text" name="pcid" id="pcid" onChange={this.nameLookup.bind(this)} />
                        <FormText>{this.state.pcidName}</FormText>
                    </FormGroup>
                    &emsp;
                    <Button type="submit" outline color="success">Add</Button>
                    &nbsp;
                    {this.state.addResponse == "yes" && <GoCheck />}
                    {this.state.addResponse == "no" && <GoCircleSlash color="#CC482B" />}
                </Form>
                <br />
                <Table striped>
                    <thead>
                        <tr>
                            <th>TargetX ID</th>
                            <th>Name (PCID)</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                    {this.state.tableData.map(data => (
                        <tr>
                            <td>{data.txid}</td>
                            <td>{data.fullname}</td>
                            <td><Button outline color="danger" onClick={() => this.deleteCounTX(data.pk)}>Delete</Button>&nbsp;
                                {this.state.deleteResponse == "yes" && data.pk == this.state.deletedVal && <GoCheck />}
                                {this.state.deleteResponse == "no" && data.pk == this.state.deletedVal && <GoCircleSlash color="#CC482B" />}
                            </td>
                        </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
            );
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(CounTX);